export const refreshCacheForURLs = ['/ref/cascade/property/ratingLevel'];
export const AVOID_API_FOR_COLUMNS = 17084; // amenities
